// This is an ad-hoc solution to fix the current UPM state on the fly.
// Once all of the plants are correctly configured in UPM, this function can be removed.
export const getAdjustedPlantId = (plantId: string) => {
  // Rollback W025 --> IT29 renaming (remove once WO25 is not used anymore)
  if (plantId === 'W025') return 'IT29'

  return plantId
}
